// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.day;
  const v$1 = x.month;
  const v$2 = x.year;
  return {
    day: v !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v) : undefined,
    month: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$1) : undefined,
    year: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$2) : undefined
  };
}

function to_json(x) {
  return {
    day: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.day),
    month: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.month),
    year: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.year)
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
